import { type TeamLevel } from '../model'

/**
 * Generate an array of numbers from `start` to `end` (inclusive)
 * @param start - the first number in the range
 * @param end - the last number in the range
 */
export function range(start: TeamLevel, end: TeamLevel): TeamLevel[]
export function range(start: number, end: number): number[]
export function range(start: number, end: number): number[] {
  // make sure we're dealing with a number rather than a string
  const rangeLength = parseInt(end) - parseInt(start) + 1
  if (rangeLength < 1) return []
  const shifted = Array.from(Array(Math.round(rangeLength)).keys())
  return shifted.map((x) => x + parseInt(start))
}

function parseInt(value: unknown): number {
  if (typeof value === 'number') return value
  if (typeof value === 'string') return Number.parseInt(value, 10)
  return 0
}
